'use strict';

exports.__esModule = true;
// TODO: deprecate these methods and move to https://github.com/sindresorhus/query-string

/**
 * Convert Object to query string
 * @param {Object} params
 * @returns {string}
 */
var jsonToQueryString = exports.jsonToQueryString = function jsonToQueryString(params) {
  var esc = encodeURIComponent;
  var query = Object.keys(params).map(function (k) {
    return esc(k) + '=' + esc(params[k]);
  }).join('&');
  return query;
};

/**
 * Converts query string to an Object
 * @param {string} url
 * @returns {Object}
 */
var parseQueryString = exports.parseQueryString = function parseQueryString() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var urlParams = {};
  url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
    urlParams[$1] = $3;
  });
  return urlParams;
};